module.exports = __webpack_public_path__ + "img/trieste_background_hero.32a0aee4.png";